import React from 'react';
import { Form, InputNumber, Row, Col, Select, Input } from 'antd';
import { SITE_OPTIONS, DEFAULT_VALUES } from '../../../constants/pricingConstants';

const { Option } = Select;

interface BasicParametersProps {
    form: any;
    categoryFromBasic: string;
    site: string;
    setSite: (site: string) => void;
    exchangeRate: number;
    setExchangeRate: (rate: number) => void;
    purchaseCostCNY: number;
    setPurchaseCostCNY: (cost: number) => void;
}

export const BasicParameters: React.FC<BasicParametersProps> = ({
    form,
    categoryFromBasic,
    site,
    setSite,
    exchangeRate,
    setExchangeRate,
    purchaseCostCNY,
    setPurchaseCostCNY,
}) => {
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Form.Item label="分类(自动)" style={{ marginBottom: 12 }}>
                        <Input
                            value={categoryFromBasic || '未填写'}
                            disabled
                            size="small"
                            style={{ color: '#666', fontSize: 12 }}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[12, 12]}>
                <Col span={8}>
                    <Form.Item label="销售站点" style={{ marginBottom: 12 }}>
                        <Select value={site} onChange={setSite} style={{ width: '100%' }} size="small">
                            {SITE_OPTIONS.map(opt => (
                                <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="汇率(USD)" style={{ marginBottom: 12 }}>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={exchangeRate}
                            onChange={(v) => setExchangeRate(v || DEFAULT_VALUES.EXCHANGE_RATE)}
                            step={0.01}
                            precision={2}
                            size="small"
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="采购成本(¥)" style={{ marginBottom: 12 }}>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={purchaseCostCNY}
                            onChange={(v) => {
                                const val = v || 0;
                                setPurchaseCostCNY(val);
                                form.setFieldsValue({ purchase_cost_cny: val });
                            }}
                            precision={2}
                            placeholder="自动读取"
                            size="small"
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};
